shvenergy.anchormenu = (function ($) {
    "use strict";
    var cdnvalue = $("#cdnInput").data("value");
    var am = $("#anchor-menu");
    var ul = $("#anchor-menu > .anchor-menu-scrollable > ul");
    var ulWidth = 0,
        maxTranslateX = 0;
    var anchors = ul.find("a");
    let anchorsArrow = ul.find("div.active-link-arrow");
    var wayponts = [];
    var resetTimeout;
    var positionLeft = 0;
    var prevButton = am.find(".anchor-menu__prev");
    var nextButton = am.find(".anchor-menu__next");
    var liWidth = 0;
    var resizeDone = true;

    function getRightAnchorItem() {
        var containerWidth = am.width();
        var rightElement;
        ul.find("li").each(function () {
            rightElement = $(this);
            if (rightElement.offset().left < containerWidth && rightElement.offset().left + rightElement.width() > containerWidth) {
                return false;
            }
        });
        return rightElement;
    }

    function goToNext() {
        var next = getRightAnchorItem().find("a");
        goToAnchor(next);
        //triggerReset();
    }

    function getLeftAnchorItem() {
        var leftOffset = positionLeft - am.width();
        var leftElement;
        var liList = ul.find("li");
        liList.each(function () {
            var $this = $(this);
            if ($this.offset().left > leftOffset) {
                leftElement = $(this);
                return false;
            }
        });
        if (!leftElement && liList.length > 0) {
            leftElement = $(ul.find("li").get(0));
        }
        return leftElement;
    }

    function goToPrevious() {
        var previous = getLeftAnchorItem().find("a");
        goToAnchor(previous);
        //triggerReset();
    }

    function calcUlWidth() {
        var width = 0;
        var wrapWidth = am[0].getBoundingClientRect().width;
        ul.find("li").each(function () {
            if (width === 0) {
                liWidth = $(this).width();
                positionLeft = $(this).position().left;
            }
            width += $(this).width();
        });

        if (width > wrapWidth) {
            width += positionLeft;
        }
        return width;
    }

    function setLiWidths() {
        var s = $(window).width() > shvenergy.utils.breakpointsObj['xxlarge'] ? shvenergy.utils.breakpointsObj['xxlarge'] : $(window).width();
        var li = ul.find('li');
        var liAmount = li.length;
        var minW = 350;
        var maxW = 500;

        if ($(window).width() >= shvenergy.utils.breakpointsObj['medium']) { //tablet or wider
            var itemW = s / liAmount;
            if (itemW > maxW) { itemW = maxW }
            else if (itemW < minW) { itemW = minW }
            anchors.css('width', itemW);
        }
        else {//mobile
            anchors.css('width', '65vw');
        }
    }

    function onResize() {
        setLiWidths();
        var wrapWidth = am[0].getBoundingClientRect().width;
        ulWidth = calcUlWidth();
        maxTranslateX = ulWidth - wrapWidth;

        if (anchors.filter("a.active").length) {
            goToAnchor(anchors.filter("a.active"));
        } else {
            goToAnchor(anchors[0]);
        }
    }

    function setupVars() {
        setLiWidths();
        var wrapWidth = am[0].getBoundingClientRect().width;
        ulWidth = calcUlWidth();
        maxTranslateX = ulWidth - wrapWidth;
    }

    function triggerReset() {
        if (resetTimeout) {
            clearTimeout(resetTimeout);
        }
        resetTimeout = setTimeout(function () {
            goToAnchor(anchors[0]);
        }, 5000);
    }

    function toggleBtn(btn, show) {
        if (show) {
            btn.animate({ opacity: 1 }, 100, function () {
                btn.show();
            });
        } else {
            btn.animate({ opacity: 0 }, 100, function () {
                btn.hide();
            });
        }
    }

    function goToAnchor(activeAnchor) {
        var index = anchors.index(activeAnchor);
        var offset = index * liWidth;
        if (offset > maxTranslateX) {
            offset = maxTranslateX + 1;
        }

        offset = parseInt(offset);

        resetHorizontalScroll();
        // ul.css({ "transform": 'translateX(-' + offset + 'px)' });
        document.querySelector("#anchor-menu .anchor-menu-scrollable").scrollLeft = offset;


        if (offset > 0) {
            toggleBtn(prevButton, true);
        } else {
            toggleBtn(prevButton, false);
        }

        if (offset >= maxTranslateX) {
            toggleBtn(nextButton, false);
        } else {
            toggleBtn(nextButton, true);
        }
    }

    function anchorMenuResize() {
        if (window.matchMedia("(min-width: 1200px)").matches) {
            $(window).on("scroll", anchorMenuScroll);
        }
        else {
            $(window).off("scroll", anchorMenuScroll);
            ul.css({
                'position': '',
                'top': ''
            });
            am.css("height", 'auto').removeClass("is-stuck");
        }
    }

    function anchorMenuScroll() {
        let offset = 71;
        let visibleTop = document.querySelector(".visible");
        let header = window.matchMedia("(min-width: 1200px)").matches ? $(".main-menu-border").outerHeight() + $(".service-menu-border").outerHeight() : $(".mobile-header").outerHeight();

        if (document.body.dataset.totopEnabled === 'True') {
            offset = 41;
        }

        if (resizeDone) {
            if ($(document).scrollTop() >= am.offset().top - offset) {
                const ulHeight = (document.body.dataset.minimizeStickyElements === 'true') ? 'auto' : ul.height();

                visibleTop ? visibleTop.style.top = header + "px" : "";
                am.css("height", ulHeight).addClass("is-stuck");

                ul.css({
                    //'position': 'absolute',
                    'z-index': '1000'
                });

                resizeDone = false;
                setTimeout(() => {
                    resizeDone = true;
                },
                    500);
            } else {
                if (visibleTop
                    && !am.hasClass("hide-all")
                    && ((am.hasClass("hide-mobile") && !window.matchMedia("(max-width: 640px)").matches && (!window.matchMedia("(max-width: 1000px)").matches || !window.matchMedia("(orientation: landscape)").matches)) ? true : (!am.hasClass("hide-mobile") ? true : false))
                ) {
                    visibleTop.style.top = $("#anchor-menu").height() - 1 + header + "px";
                }
                ul.css({
                    'position': '',
                    'top': ''
                });
                am.css("height", 'auto').removeClass("is-stuck");
            }
        }
    }

    function init() {

        if (am.length) {
            let alertCloseButton = $("[data-alertbanner]").find("[data-alertclose]");

            setupVars();
            setupArrowButtons();
            onResize();
            $(window).on("resize", onResize);
            nextButton.on("click", goToNext);
            prevButton.on("click", goToPrevious);
            anchors.each(function (idx) {
                $(this).data('index', idx);

                // $(this).on('touchstart', (e) => {
                // adjustAnchorMenuScrollTranslate();
                // });

                $(this).on("click", function (e) {
                    e.preventDefault();

                    var id = $(this).attr("href");
                    let mainTopPadding = $("#main").css("padding-top");
                    let reduceScroll = 95;

                    if (mainTopPadding == "0px") {
                        reduceScroll = 25;
                    }

                    if (window.matchMedia("(min-width: 1200px)").matches) {
                        const offset = 220 + 71;

                        $("html, body").animate({ scrollTop: $(id).offset().top - 190 }, 350);
                    } else if (window.matchMedia("(max-width: 640px)").matches && window.matchMedia("(orientation: portrait)").matches) {
                        $("html, body").animate({ scrollTop: $(id).offset().top - reduceScroll }, 350);
                    } else {
                        $("html, body").animate({ scrollTop: $(id).offset().top - 105 }, 350);
                    }
                    // adjustAnchorMenuScrollTranslate();
                });

                if (alertCloseButton.length) {
                    alertCloseButton.on("click", function () {
                        Waypoint.refreshAll();
                    });
                }
            });

            //Anchor menu is present on the page, now pull in waypoints library

            $.getScript("" + cdnvalue + "/dist/js/waypoints.js").done(function (data, script, textStatus) {

                var continuousElements = $(".anchor-header");
                for (var i = 0; i < continuousElements.length; i++) {
                    wayponts.push(
                        new Waypoint({
                            element: continuousElements[i],
                            handler: function (direction) {
                                if (direction === 'up') {
                                    handleWaypointScrolling(this.element);
                                }
                            },
                            offset: 0
                        })
                    );

                    wayponts.push(
                        new Waypoint({
                            element: continuousElements[i],
                            handler: function (direction) {
                                if (direction === 'down') {
                                    handleWaypointScrolling(this.element);
                                }
                            },
                            offset: '45%'
                        })
                    );
                }
                //Waypoint.refreshAll();
            }).fail(function (jqxhr, settings, exception) {
                console.log("Triggered ajaxError handler.");
            });

            anchorMenuScroll();

            $(window).on("scroll", anchorMenuScroll);

            $(window).on("resize", anchorMenuScroll);


            //Needed if there's an anchor in the URL
            //ie. http://localhost:3000/testpages/anchorheader#enter-from-right-100
            var hashId = location.hash.substr(1);
            if (hashId != '') {
                setTimeout(onResize, 50);
                onResize();

                $("html, body").animate({ scrollTop: $('#' + hashId).offset().top - 220 }, 350);
                $(window).trigger("scroll");
                history.replaceState({}, document.title, location.href.substr(0, location.href.length - location.hash.length));
            }

        }
    }

    function setupArrowButtons() {
        if (ul.innerHeight() < 60) {
            nextButton.addClass("single_line_text");
            prevButton.addClass("single_line_text");
        }
    }

    function handleWaypointScrolling(el) {
        anchors.removeClass("active");
        anchorsArrow.removeClass("active");

        var header = $(el).find("h2");
        var id = header.attr("id");
        var activeAnchor = anchors.filter("[href='#" + id + "']");
        activeAnchor.next().addClass("active");
        activeAnchor.addClass("active");
        goToAnchor(activeAnchor);
    }

    // function adjustAnchorMenuScrollTranslate() {
    //     if (ul[0].style) {
    //         let scrollableMenu = document.querySelector("#anchor-menu .anchor-menu-scrollable");

    //         let ulTransformStyle = ul[0].style.transform,
    //             translateXValue = parseInt(ulTransformStyle.substring(11).slice(0,-3)),
    //             scrollXValue = scrollXValue = ul[0].scrollLeft,
    //             scrollAmount = 0;

    //         if (translateXValue === 0) {
    //             scrollAmount = parseInt(scrollXValue);
    //         }
    //         else {
    //             scrollAmount = parseInt(translateXValue);
    //         }

    //         if (scrollAmount !== 0) {
    //             ul.css({ "transform": 'translateX(0px)' });
    //             ul.scrollLeft(Math.abs(scrollAmount));

    //             scrollableMenu.scrollLeft = 50;
    //             $(scrollableMenu).scrollLeft(scrollAmount);
    //         }
    //     }
    // }

    function resetHorizontalScroll() {
        let ams = document.querySelector('.anchor-menu-scrollable');

        ams.scrollLeft = 0;
    }

    init();

})(jQuery);